import { connect } from 'react-redux';
import { BANK_STATMENT_DOC_TYPE } from '../../../../modals/uploadDocumentsModal/UploadDocumentsModalHelper';
import { isFlexiLoanBankStatementRequired } from '../../../../multiLoanDashboard/multiLoanDashboardSelector';
import { UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT } from '../../../ApplyFlexiLoanView.actions';
import { Dispatch } from 'redux';
import { RootState } from '@iwProvider/configureStore';
import styles from './LatestBankStatements.module.css';
import { TrueLayer } from '../../../../modals/linkOpenBankingModal/trueLayer';
import { FormattedMessage } from 'react-intl';
import messages from './LatestBankStatements.messages';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    uploadBankStatementDocument: () => {
        dispatch({
            type: UPLOAD_FLEXI_LOAN_DOCUMENT_REQUIREMENT,
            documentType: BANK_STATMENT_DOC_TYPE
        });
    }
});

const mapStateToProps = (state: RootState) => {
    return {
        isBankStatementsRequired: isFlexiLoanBankStatementRequired(state)
    };
};

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const LatestBankStatements = ({
    uploadBankStatementDocument,
    hasSubmitFailed,
    isBankStatementsRequired
}: { hasSubmitFailed: boolean } & PropsFromRedux) => {
    return (
        <div className={styles.connectOpenBanking}>
            <TrueLayer
                handleUploadBankStatements={uploadBankStatementDocument}
            />

            {isBankStatementsRequired && hasSubmitFailed && (
                <p data-testid="formErrors" className={styles.error}>
                    <FormattedMessage {...messages.submitFailed} />
                </p>
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LatestBankStatements);
